/* global global */

// Third-party imports

// Local imports
// polyfills must be applied before everything else
import '../../polyfill/index.js';

import * as sghome_datalayer from './datalayer.js';
import * as event from '../../datalayer/event.js';
import * as gtm_vars from '../../datalayer/gtm/gtm_vars.js';
import * as gtm_push from '../../datalayer/gtm/gtm_push.js';
import * as global_mod from '../../global/index.js';
import { PAGE_VARS, PageKind } from '../vars.js';
import * as tealium from '../../datalayer/tealium.js';
import * as general_donation_cta from '../../global/general_donation_cta.js';

import * as shopify_data from './shopify_data.js';

// --------------------------------------------------------------------------
// Module vars
// --------------------------------------------------------------------------
// Module name
export const MODULE_NAME = 'sghome';

export let global_vars = {};

// --------------------------------------------------------------------------
// Functions
// --------------------------------------------------------------------------
class ShopifyData {
    constructor(data_element) {
        this.data_element = data_element;
    }

    datalayer() {
        let all_datalayer = this.data_element.querySelectorAll('.datalayer');
        for (let datalayer of all_datalayer) {
            let data = datalayer.dataset;

            let prod_cat_name = data.product_category_name;
            shopify_data.save_sghome_datalayer(
                {
                    id: data.product_id,
                    name: data.product_name,
                    category_name: `${prod_cat_name}/ /International`,
                    sku: data.product_sku,
                    variants: JSON.parse(data.product_variants),
                    price: data.product_price,
                    img_url: data.product_img_url,
                },
                data.product_ispromo,
                data.product_position,
                data.product_listname
            );

            shopify_data.save_sghome_click_datalayer(
                // ispromo
                data.click_ispromo,

                // promo
                {
                    id: data.click_promo_id,
                    name: data.click_promo_name,
                    creative: data.click_promo_creative,
                    position: data.click_promo_position,
                },

                // product
                {
                    id: data.click_product_id,
                    price: data.click_product_price,
                    name: data.click_product_name,
                    listname: data.click_product_listname,
                    position: data.click_product_position,
                }
            );
        }
    }

    footer() {
        let footer = this.data_element.querySelector('.footer');
        let data = footer.dataset;

        shopify_data.save_sghome_footer_datalayer(
            // footer
            {
                id: data.footer_id,
                name: data.footer_name,
                img_url: data.footer_img_url,
                position: data.footer_position,
            },

            // click
            {
                total: data.click_total,
                name: data.click_name,
                creative: data.click_creative,
                position: data.click_position,
            }
        );
    }

    card() {
        // Save list of all card ids
        let data = this.data_element.dataset;
        shopify_data.save_sghome_cardid(data.card_idlist);
    }

    run() {
        this.datalayer();
        this.footer();
        this.card();
    }
}

function process_shopify_data(global) {
    const SHOPIFY_DATA = shopify_data.SHOPIFY_DATA;

    let data_element = global.document.getElementById('sghome-data');
    let shpdata = new ShopifyData(data_element);
    shpdata.run();

    // Product
    for (let d of SHOPIFY_DATA.product) {
        sghome_datalayer.update_sghome_datalayer(
            d.product,
            d.ispromo,
            d.position,
            d.listname
        );
    }

    // Footer
    for (let d of SHOPIFY_DATA.footer) {
        sghome_datalayer.update_sghome_footer_datalayer(d.footer);
        setup_footerclick_event(global, d.click);
    }

    // Click
    setup_click_event(global);
}

// TODO: this isn't really a footer thing, is this? Analyze and, if needed,
// refactor
function setup_footerclick_event(global, data) {
    // Find all elements with class button
    let all_buttons = global.document.querySelectorAll('.button');

    for (let btn of all_buttons) {
        btn.addEventListener('click', () => {
            sghome_datalayer.update_sghome_footerclick_datalayer(global, data);
            event.dispatch(global, event.EventKind.PromoClick);
        });
    }
}

function setup_click_event(global) {
    const SHOPIFY_DATA = shopify_data.SHOPIFY_DATA;

    // Find element w/ id of position_id
    for (let card_id of SHOPIFY_DATA.cardid) {
        let position_id = global.document.querySelector(`#${card_id}`);
        position_id.addEventListener('click', () => {
            let data_el = global.document.querySelector(`#${card_id}_data`);
            let dataset = data_el.dataset;

            push_gtm_click_data(dataset);

            // Old utag push
            for (let d of SHOPIFY_DATA.click) {
                if (d.product.id === dataset.product_id) {
                    sghome_datalayer.update_sghome_click_datalayer(
                        global,
                        d.ispromo,
                        d.promo,
                        d.product
                    );
                    event.dispatch(global, event.EventKind.ProductClick);
                }
            }
        });
    }
}

function push_gtm_click_data(dataset) {
    //== gtm-push: ODN Product clicked ==//
    let data_object = {
        event: 'select_item',
        ecommerce: {
            items: [
                {
                    item_name: dataset.product_name,
                    item_id: dataset.product_id,
                    price: dataset.product_price,
                    item_category: 'Donations',
                    item_variant: dataset.product_variants,
                    item_list_name: 'Donations',
                    index: dataset.product_position,
                },
            ],
        },
    };

    gtm_push.push_data_object(data_object);
}

function post_donation_cta_promo(global) {
    let data_element = global.document.getElementById('donation_cta_datalayer');
    let dataset = data_element.dataset;

    global.promotions.push({
        promotion_name: dataset.promo_name,
        promotion_id: dataset.promo_id,
        creative_name: dataset.category_name,
        creative_slot: 'donation_cta',
    });

    global.uaPromotions.push({
        name: dataset.promo_name,
        id: dataset.promo_id,
        category: dataset.category_name,
        position: 'donation_cta',
    });
}

function init_pagevars() {
    PAGE_VARS.kind = PageKind.Donation;
}

function initialize(global) {
    process_shopify_data(global);
    post_donation_cta_promo(global);
}

export function main() {
    // Initialize all page vars
    init_pagevars();

    // Create object to pass to global initialization
    let all_modules = global_mod.__all__;
    let product_mod = {
        MODULE_NAME,
        global_vars,
        initialize,
    };

    all_modules.push(gtm_vars, product_mod, general_donation_cta, gtm_push);

    // Insert datalayer setup module and tealium module at the beginning and end
    // of the modules array respectively
    all_modules = tealium.wrap_module_array(all_modules);

    // Initialize globals
    // The ``global`` global variable will be ``window`` when run in a browser
    // context.
    global_mod.initialize(global, all_modules);
}
